import Request from './request'
import store from '@/store.js';
import i18n from '@/i18n';
import snackbar from '@/plugins/snackbar';

async function fetch(data){
    return Request("get","api/receipt/bill-analyze",data)
}

async function billAnalyzeCountExport(data) {// 应收应付统计下载
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/bill-analyze-count-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}


async function billAnalyzeShopOrderExport(data) {// 要货对账单批量下载
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/billAnalyzeShopOrderExport/", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function exportOne(id, data) {// 单个下载 
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/billAnalyzeShopOrderExport/" + id, data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function billAnalyzeExport(data) {//导出excel
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/billAnalyzeExport", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function getBillAnalyzeHistory(data){
    return Request("get","api/receipt/bill-analyze-history",data)
}

async function getMaterialProfitAnalyzeHistories(data){
    return Request("get","api/material-profit-analyze-histories/index",data)
}

async function materialProfitAnalyzeHistoriesExport(data) {//导出excel
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/material-profit-analyze-histories/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function billAnalyzeHistoryExport(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/ receipt/bill-analyze-history-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}


export default {
    fetch,
    billAnalyzeCountExport,
    billAnalyzeShopOrderExport,
    exportOne,
    billAnalyzeExport,
    getBillAnalyzeHistory,
    billAnalyzeHistoryExport,
    getMaterialProfitAnalyzeHistories,
    materialProfitAnalyzeHistoriesExport,
}